// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__Rh4Yl","logo":"Navbar_logo__VNeUG","menu":"Navbar_menu__l1FWr","link":"Navbar_link__PG2jz"};